import React from 'react';
import { Tooltip, NonIdealState, Button, Position, Intent, Card } from "@blueprintjs/core";

class CreatePanelProtocolMSTable extends React.Component {
    handleDeleteCriteria = (id) => {
        const { onDeleteCriteria } = this.props;

        onDeleteCriteria(id);
    }

    render() {
        const { criterias, onOpenDialog, instances = [] } = this.props;

        if (!criterias || criterias.length <= 0)
            return (
                <Card>
                    <NonIdealState
                        icon="selection"
                        title="No Criterias Yet"
                        description="You need to add at least one evaluation criteria"
                        action={<Button
                            intent={Intent.PRIMARY}
                            disabled={criterias ? criterias.length >= 5 : null}
                            rightIcon="add"
                            text="Add Criterias"
                            onClick={onOpenDialog} />} />
                </Card>
            );
        return (
            <Card>
                <div className="text-right">
                    <Tooltip
                        disabled={criterias.length < 5}
                        content="You have reached the maximum amount of criterias"
                        position={Position.TOP_LEFT} >
                        <Button
                            intent={Intent.PRIMARY}
                            disabled={criterias.length >= 5 || instances.length !== 0}
                            rightIcon="add"
                            text="Add Criterias"
                            style={{ marginBottom: '20px' }}
                            onClick={onOpenDialog} />
                    </Tooltip>
                </div>
                <Card>
                    <table className="bp3-html-table full-width">
                        <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Min</th>
                                <th>Max</th>
                                <th>Default</th>
                                <th>Step</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {criterias.map((c, index) =>
                                <tr key={index}>
                                    <td>{c.name}</td>
                                    <td>{(c.type === 'CLOSE' || !c.type) ? c.min : ''}</td>
                                    <td>{(c.type === 'CLOSE' || !c.type) ? c.max : ''}</td>
                                    <td>{(c.type === 'CLOSE' || !c.type) ? c.default : ''}</td>
                                    <td>{(c.type === 'CLOSE' || !c.type) ? c.step : ''}</td>
                                    <td style={{ textAlign: "right" }}>
                                        <Button
                                            icon="trash"
                                            minimal={true}
                                            onClick={() => this.handleDeleteCriteria(c.id)}
                                            disabled={instances.length !== 0} />
                                    </td>
                                </tr>)}
                        </tbody>
                    </table>
                </Card>
            </Card>
        );
    }
}

export default CreatePanelProtocolMSTable